import { IconAlertCircle, IconInfoCircle } from "@tabler/icons-react"
import { InfoBox, Loader } from "@tfg/ui"
import _ from "lodash"
import { useState } from "react"

import { ProductSheetLanguages } from "@tfg/types/constants/language.constants"
import { TEXT_COMPONENTS } from "@tfg/types/schemas/communication-studio/components"
import { ComponentTypesEnum } from "@tfg/types/types/communication-studio/components.types"

import {
  GetProductPageComponentsResponseDto,
  useGetProductPageComponents,
} from "~/gen/api"
import { EditComponentModalV2 } from "~/pages/Brand/CommunicationStudio/Languages/components/EditComponentModalV2"
import { EditProductComponentModal } from "~/pages/Brand/CommunicationStudio/Languages/components/EditProductComponentModal"
import { TranslationCard } from "~/pages/Brand/CommunicationStudio/Languages/components/TranslationCard"
import { useGetCurrentLanguage } from "~/pages/Brand/CommunicationStudio/Languages/utils/productSheetLanguages"
import { useProductSheetGroup } from "~/pages/Brand/CommunicationStudio/contexts/productSheetGroup/useProductSheetGroup"

export const TranslationsEditor = () => {
  const [isContentModalOpen, setIsContentModalOpen] = useState(false)
  const [selectedComponent, setSelectedComponent] =
    useState<GetProductPageComponentsResponseDto | null>(null)
  const { selectedProductSheetGroup } = useProductSheetGroup()
  const { data, isLoading, isError } = useGetProductPageComponents(
    selectedProductSheetGroup?.id ?? ""
  )

  const currentLanguage = useGetCurrentLanguage() ?? ProductSheetLanguages.EN
  const pageComponents = data?.data
    .sort((a, b) => a.order - b.order)
    .filter((component) => !_.isEmpty(component.content))

  if (isLoading) {
    return <Loader />
  }

  if (isError) {
    return (
      <InfoBox
        title="Error"
        message="Please try again later"
        icon={<IconAlertCircle />}
      />
    )
  }
  if (!pageComponents || pageComponents.length === 0) {
    return (
      <InfoBox
        title="No components found"
        message="Please add a component to the product sheet"
        icon={<IconInfoCircle />}
      />
    )
  }

  return (
    <>
      {pageComponents.map(
        (component, index) =>
          TEXT_COMPONENTS.includes(component.componentType) && (
            <TranslationCard
              key={`${component.componentType}-${index}`}
              component={component}
              language={currentLanguage}
              handleEdit={(component) => {
                setIsContentModalOpen(true)
                setSelectedComponent(component)
              }}
            />
          )
      )}
      {selectedComponent &&
        isContentModalOpen &&
        ([
          ComponentTypesEnum.TEXT_PARAGRAPH,
          ComponentTypesEnum.TEXT_HEADER,
          ComponentTypesEnum.GENERIC_PASSPORT_TITLE,
        ].includes(selectedComponent.componentType) ? (
          <EditProductComponentModal
            selectedComponent={selectedComponent}
            onClose={() => setIsContentModalOpen(false)}
            isOpen={isContentModalOpen}
          />
        ) : (
          <EditComponentModalV2
            selectedComponent={selectedComponent}
            onClose={() => setIsContentModalOpen(false)}
            isOpen={isContentModalOpen}
            defaultLanguage={currentLanguage}
          />
        ))}
    </>
  )
}
